import { List, styled } from "@mui/material"

const StyledList = styled(List)`
  width: 100%;
`
export default StyledList
